import React from 'react';
import styled from 'styled-components';
import DeviceType from 'features/POSRegisters/interfaces/DeviceType';
import UnsupportedDeviceMessage from 'features/POSRegisters/components/UnsupportedDeviceMessage';

//#endregion styles
const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  padding-top: 8px;
  gap: 16px;
`;

//#endregion styles

interface UnsupportedSummaryProps {
  deviceType: DeviceType;
}

export default function UnsupportedSummary({deviceType}: UnsupportedSummaryProps) {
  return (
    <StyledContainer>
      <UnsupportedDeviceMessage deviceType={deviceType} />
    </StyledContainer>
  );
}
